export default [
  // Main Page
  {
    path: 'utm-analystics',
    name: 'website.utm-analystics',
    component: () => import('@/views/website/utm-analystics'),
  },
];
